module.exports = __webpack_public_path__ + "static/why_1-bc314dfb5742fb64adbf0af3d7c8b8ed.gif";